import { render, staticRenderFns } from "./Settled.vue?vue&type=template&id=fd7ee1c2"
import script from "./Settled.vue?vue&type=script&lang=ts"
export * from "./Settled.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports